import React from 'react';
import { Filter, X } from 'lucide-react';

const FILTER_LABELS = {
  toContact: 'Showing patients to contact',
  contacted: 'Showing in-progress patients',
  responded: 'Showing recovered & closed patients',
  followUp: 'Showing patients needing follow-up',
  engaged: 'Showing engaged but not booked patients',
};

const FilterBanner = ({ activeFilter, totalCount, onClear }) => {
  if (!activeFilter) return null;

  return (
    <div className="flex items-center justify-between bg-emerald-50 border border-emerald-200 rounded-lg px-4 py-3">
      <div className="flex items-center gap-2">
        <Filter className="h-4 w-4 text-emerald-600" strokeWidth={1.5} />
        <span className="text-sm font-medium text-emerald-800">
          {FILTER_LABELS[activeFilter]}
        </span>
        <span className="text-sm text-emerald-600">
          ({totalCount} patients)
        </span>
      </div>
      <button
        onClick={onClear}
        className="flex items-center gap-1 px-2 py-1 text-sm font-medium text-emerald-700 hover:bg-emerald-100 rounded transition-colors"
      >
        <X className="h-3.5 w-3.5" strokeWidth={2} />
        Clear filter
      </button>
    </div>
  );
};

export default FilterBanner;
